import React, { useEffect } from "react";
import "./payment.css";
import { Row, Col, FormGroup, Button, Container, Table } from "reactstrap";
import { FaCheckCircle, FaLock, FaTimes } from "react-icons/fa";
import { appConstants } from "../../_constants";
import moment from "moment";
// import EPIBSLogo from "../../assets/images/ebips-assets/ebips-logo.svg";
import EPIBSLogo from "../../assets/images/ebips-assets/ebips-logo.png";
import axios from "axios";
import { connect } from "react-redux";
import { paymentsService } from "../../_services";
import { alertActions } from "../../_actions";
import { LoaderMobile } from "./loading";
import { RenderAlertMobileModal } from "../../components/MobileModal";
import { appHelpers } from "../../_helpers";
import { FaCopy } from "react-icons/fa";

let source;

class PaymentSecurity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isRequesting: false,
      error: false,
      componentErrorMessages: [],
      componentError: false,
      invoiceNumber: "",
      code: "",
      invoiceDetails: {},
      validResponse: null,
      showAlertModal: false,
      alertIcon: "",
      alertMessage: "",
      copySuccess: false,
      lastPayload: null,
      hasTried: false,
    };
    source = axios.CancelToken.source();
    this.handleCopyClick = this.handleCopyClick.bind(this);
  }

  componentDidMount() {
    this.validateInvoiceQR();
  }

  hideAlertView = (response) => {
    this.setState({ showAlertModal: response });
  };

  copyToClipboard = (textToCopy) => {
    const el = document.createElement("textarea");
    el.value = textToCopy;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);

    // Set copySuccess to true and then reset it after 2.5 seconds
    this.setState({ copySuccess: true });
    setTimeout(() => this.setState({ copySuccess: false }), 2500);
  };

  // handleCopyClick = () => {
  //   // Call copyToClipboard with invoiceNumber
  //   this.copyToClipboard(this.props.invoiceDetails?.invoiceNumber);
  // };

  handleCopyClick = () => {
    // Check if invoiceDetails exists before copying
    const { invoiceDetails } = this.state;
    if (invoiceDetails && invoiceDetails.invoiceNumber) {
      this.copyToClipboard(invoiceDetails.invoiceNumber);
    }
  };

  // validateInvoiceQR = () => {
  //   let { dispatch, location } = this.props;

  //   const urlSearchParams = new URLSearchParams(location.search);
  //   const inv = urlSearchParams.get("inv");
  //   const code = urlSearchParams.get("code");

  //   let payload = {
  //     inv: inv,
  //     code: code,
  //   };
  //   this.setState({ lastPayload: payload, hasTried: true, validResponse: null });
  //   dispatch(alertActions.startRequest());
  //   paymentsService.validateQR(payload).then((res) => {
  //     let response = res.response;
  //     dispatch(alertActions.stopRequest());
  //     if (res.status === appConstants.SUCCESS_RESPONSE) {
  //       this.setState({
  //         invoiceDetails: response,
  //         validResponse: true,
  //       });
  //     } else if (res.status === appConstants.ERROR_RESPONSE) {
  //       this.displayErrorResponseAlert(response, true);
  //     }
  //   });
  // };

  validateInvoiceQR = () => {
    const { dispatch, location } = this.props;

    const urlSearchParams = new URLSearchParams(location.search);
    const inv = urlSearchParams.get("inv");
    const code = urlSearchParams.get("code");

    const payload = { inv, code };

    // save for retry + mark attempted
    this.setState({
      lastPayload: payload,
      hasTried: true,
      validResponse: null,
    });

    dispatch(alertActions.startRequest());

    paymentsService
      .validateQR(payload)
      .then((res) => {
        const response = res.response;
        dispatch(alertActions.stopRequest());

        if (res.status === appConstants.SUCCESS_RESPONSE) {
          this.setState({
            invoiceDetails: response,
            validResponse: true,
            showAlertModal: false,
          });
        } else {
          // any non-success response should show modal + keep retry option on page
          this.setState({ validResponse: false });
          this.displayErrorResponseAlert(response, true);
        }
      })
      .catch((err) => {
        dispatch(alertActions.stopRequest());
        this.setState({ validResponse: false });

        // pick the best message you can
        const msg =
          err?.response?.data?.message ||
          err?.message ||
          "Unable to validate invoice at the moment. Please try again.";

        this.displayErrorResponseAlert(msg, true);
      });
  };

  handleRetry = () => {
    const { requesting } = this.props;
    const { lastPayload } = this.state;

    // avoid double click spam
    if (requesting) return;

    // If we already saved payload, re-run with it; otherwise fall back to full parsing
    if (lastPayload?.inv && lastPayload?.code) {
      const { dispatch } = this.props;

      dispatch(alertActions.startRequest());
      this.setState({ validResponse: null });

      paymentsService
        .validateQR(lastPayload)
        .then((res) => {
          const response = res.response;
          dispatch(alertActions.stopRequest());

          if (res.status === appConstants.SUCCESS_RESPONSE) {
            this.setState({
              invoiceDetails: response,
              validResponse: true,
              showAlertModal: false,
            });
          } else {
            this.setState({ validResponse: false });
            this.displayErrorResponseAlert(response, true);
          }
        })
        .catch((err) => {
          dispatch(alertActions.stopRequest());
          this.setState({ validResponse: false });

          const msg =
            err?.response?.data?.message ||
            err?.message ||
            "Unable to validate invoice at the moment. Please try again.";

          this.displayErrorResponseAlert(msg, true);
        });

      return;
    }

    // fallback
    this.validateInvoiceQR();
  };

  displayErrorResponseAlert = (response, action, query) => {
    const { dispatch } = this.props;
    if (response === "Please Check your internet connectivity") {
      dispatch(alertActions.error(response));
    } else if (typeof response === "string") {
      this.setState(
        {
          showAlertModal: true,
          alertIcon: <FaTimes size={30} color={appConstants.DANGER_COLOR} />,
          alertMessage: response,
        },
        () => {
          appHelpers.dismissModal.call(this, "showAlertModal");
          if (action) {
            return query;
          }
        }
      );
    } else {
      this.setState(
        {
          showAlertModal: true,
          alertIcon: <FaTimes size={20} color={appConstants.DANGER_COLOR} />,
          alertMessage: response ? response.message : "",
        },
        () => {
          appHelpers.dismissModal.call(this, "showAlertModal");
          if (action) {
            return query;
          }
        }
      );
    }
  };

  handlePaymentClick = () => {
    const { invoiceDetails } = this.state;
    if (invoiceDetails && invoiceDetails.paymentLink) {
      window.open(invoiceDetails.paymentLink, "_blank");
    } else {
      console.error("Payment link is not available.");
    }
  };
  render() {
    const { userData, match } = this.props;
    const { requesting } = this.props;
    const {
      invoiceDetails,
      validResponse,
      showAlertModal,
      alertIcon,
      alertMessage,
      copySuccess,
      hasTried,
    } = this.state;
    // let logo = userData.logoUrl ? userData.logoUrl : EPIBSLogo;
    return (
      <>
        <div className="card-payment">
          <Row>
            <Col sm={12} lg={6}>
              {/* Logo always shows */}
              <Row className="agency-logo">
                <div>
                  <img 
                    src={validResponse === true ? invoiceDetails.logoUrl : EPIBSLogo} 
                    alt="logo" 
                  />
                </div>
              </Row>

              {/* Page heading always shows */}
              <Row>
                <Col>
                  <h2 className="invoice-authHead">QR Code Verification</h2>
                </Col>
              </Row>

              {/* Loading State - Validation in progress */}
              {!hasTried && requesting && (
                <Row>
                  <Col>
                    <p className="invoice-details" style={{ textAlign: "center", marginTop: "20px" }}>
                      Validating your QR code, please wait...
                    </p>
                  </Col>
                </Row>
              )}

              {/* Error State - Validation failed */}
              {hasTried && validResponse === false && (
                <>
                  <Row>
                    <Col>
                      <p
                        className="invoice-auth"
                        style={{ color: appConstants.DANGER_COLOR }}
                      >
                        Unable to Validate Invoice
                      </p>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <p className="invoice-details">
                        We couldn't validate this QR right now. This is often
                        temporary (network/server).
                        <br />
                        Please retry.
                      </p>
                    </Col>
                  </Row>

                  <Row style={{ margin: "20px", justifyContent: "center" }}>
                    <Col lg={12} sm={12} className="center-button">
                      <button
                        className="payment-button"
                        onClick={this.handleRetry}
                        disabled={requesting}
                        style={{ opacity: requesting ? 0.6 : 1 }}
                      >
                        {requesting ? "Retrying..." : "Retry Validation"}
                      </button>
                    </Col>
                  </Row>

                  <Row className="payment-status">
                    <Col className="center-content">
                      <FaLock color="#BABABA" />
                      <p className="payment-secure">Payment secured</p>
                    </Col>
                  </Row>
                </>
              )}

              {/* Success State - Validation successful */}
              {validResponse === true && (
                <>
                  <Row>
                    <Col>
                      <p className="invoice-auth">Invoice Authenticated</p>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <p className="invoice-details">
                        {invoiceDetails.message}
                      </p>
                    </Col>
                  </Row>

                  <Row className="payment-logo">
                    <Col sm={12} lg={12} md={12} className="center-logo">
                      <FaCheckCircle
                        size={100}
                        color={appConstants.SUCCESS_COLOR}
                      />
                    </Col>
                  </Row>

                  <div style={{ marginBottom: "30px" }}>
                    <Row
                      style={{
                        backgroundColor: "#FAFAFA",
                        borderRadius: "10px",
                        width: "330px",
                        height: "70px",
                        margin: "auto",
                        padding: "8px",
                      }}
                    >
                      <Col xs="4" className="custom-stract">
                        <div className="custom-column">Invoice Date:</div>
                        <div className="down-column">
                          {moment(invoiceDetails?.invoiceDate).format(
                            "YYYY-MM-DD"
                          )}
                        </div>
                      </Col>
                      <Col xs="4" className="custom-container">
                        <div className="custom-column">Invoice No:</div>
                        <div className="down-column">
                          {invoiceDetails?.invoiceNumber}
                          {copySuccess && (
                            <span
                              style={{ fontSize: "10px", fontWeight: "bold" }}
                              className="tooltips"
                            >
                              Copied!
                            </span>
                          )}
                        </div>
                        <FaCopy
                          onClick={this.handleCopyClick}
                          style={{ cursor: "pointer" }}
                          color="green"
                        />
                      </Col>
                      <Col xs="4" className="custom-container">
                        <div className="custom-column">Amount:</div>
                        <div className="down-column">
                          {appHelpers.numberWithCommasOnly(
                            invoiceDetails?.amountString
                          )}
                        </div>
                      </Col>
                    </Row>
                  </div>

                  {invoiceDetails.deleted === false &&
                    invoiceDetails.agencyId === 20 &&
                    invoiceDetails.amountPaid !==
                      invoiceDetails.invoiceAmount && (
                      <>
                        <Row
                          style={{ margin: "20px", justifyContent: "center" }}
                        >
                          <Col lg={12} sm={12} className="center-button">
                            <button
                              className="payment-button"
                              onClick={this.handlePaymentClick}
                            >
                              Make Payment
                            </button>
                          </Col>
                        </Row>

                        <Row className="payment-status">
                          <Col className="center-content">
                            <FaLock color="#BABABA" />
                            <p className="payment-secure">Payment secured</p>
                          </Col>
                        </Row>
                      </>
                    )}
                </>
              )}
            </Col>
          </Row>
        </div>

        {/* Loader overlay - shows during API requests */}
        {requesting && <LoaderMobile />}

        {/* Alert modal */}
        {showAlertModal && (
          <RenderAlertMobileModal
            message={alertMessage}
            icon={alertIcon}
            showAlertModal={showAlertModal}
            hideAlertView={this.hideAlertView}
          />
        )}
      </>
    );
  }
}
function mapStateToProps(state) {
  const { alert, user, requesting, baseRoute, userData, appRequesting } = state;
  return {
    alert,
    user,
    requesting,
    baseRoute,
    userData,
    appRequesting,
  };
}
export default connect(mapStateToProps)(PaymentSecurity);
